import React from 'react';
import { ChipCloseIcon } from 'components/icons';
import { textToColor } from 'helpers/textToColor/textToColor';
import { cleanString } from 'helpers/utils/util';
import { useProductList } from '../../context';

const CurrentRefinements = ({ textConfig }: { textConfig?: Record<string, string> }) => {
  const [announcement, setAnnouncement] = React.useState('');
  const { activeRefinements, removeAllRefinements } = useProductList();

  if (!activeRefinements.length) return <></>;

  return (
    <div className="flex flex-wrap items-center justify-start gap-14 pl-6 pt-16 lg:pl-0" data-ffid="ctr-parent-chips">
      {activeRefinements.map((refinement, index) => (
        <div
          key={refinement.label}
          data-ffid={`ctr-chip-${cleanString(refinement.label)}-${index}`}
          className="flex cursor-default items-center justify-center gap-8 rounded-md bg-[#F5F5F5] py-4 pl-16 pr-4 transition hover:border-primary"
        >
          <span
            data-ffid={`lbl-chip-${cleanString(refinement.label)}-${index}`}
            className="text-14 leading-[20px] text-[#5C5C5C]"
          >
            {refinement.label?.includes(':') ? textToColor(refinement.label).label : refinement.label}
          </span>
          <button
            data-ffid={`btn-chip-close-${index}`}
            className="w-20 cursor-pointer fill-gray-600 stroke-0"
            aria-label={`${refinement?.label} close`}
            onClick={() => {
              refinement.refine();
              setAnnouncement(`${refinement.label} removed`);
            }}
            type="button"
          >
            <ChipCloseIcon />
          </button>
        </div>
      ))}
      <button
        className="flex cursor-pointer items-center justify-center gap-8 rounded-md border border-transparent bg-white px-8 py-6 text-[#0B57D0] transition"

        onClick={() => {
          removeAllRefinements();
          setAnnouncement('All filters cleared');
        }}
        type="button"
      >
        <span data-ffid={`btn-chips-clearall`} className="text-14">
          {textConfig?.clearAll ?? 'Clear All'}
        </span>
      </button>

      <div aria-live="polite" aria-atomic="true" className="sr-only">
        {announcement}
      </div>
    </div>
  );
};

export default CurrentRefinements;
